<div [ngClass]="containerClasses()">
  @for (item of counter(count()); track $index) {
    <div class="product-card-skeleton">
      <div class="product-card-skeleton__flex">
        <ngx-skeleton-loader
        count="1"
        class="flex gap-30"
        [theme]="{
          width: '4em',
          height: '1.5em',
          'border-radius': '0.25em',
        }"></ngx-skeleton-loader>

        <ngx-skeleton-loader
        count="1"
        class="flex gap-30"
        [theme]="{
          width: '1.5em',
          height: '1.5em',
          'border-radius': '0.25em',
        }"></ngx-skeleton-loader>
      </div>
      <ngx-skeleton-loader
        count="1"
        class="flex gap-30"
        [theme]="{
          width: '16.5em',
          height: '16.75em',
          'border-radius': '0.625em',
        'margin-bottom': '1.25em',
        }"></ngx-skeleton-loader>

    <div  class="product-card-skeleton__flex">
      <pwj-card-property-skeleton
      [count]="1"
      class="flex"></pwj-card-property-skeleton>
      
      <ngx-skeleton-loader
      count="1"
      class="flex gap-30"
      [theme]="{
        width: '3em',
        height: '1.5em',
        'border-radius': '0.25em',
        'margin-top': '0.375em',
      }"></ngx-skeleton-loader>
    </div>
      <ngx-skeleton-loader
        count="2"
        class="w-full flex gap-30"
        [theme]="{
          height: '1.5em',
          'border-radius': '0.25em',
          'margin-bottom': '0',
        }"></ngx-skeleton-loader>
    </div>
  }
</div>
